// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, recordOf, arrayOf, enumOf } from "@altostra/type-validations";
import { string, boolean, any, number } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants.json";

export const isEngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      type: enumOf(
        sharedConstants.FEATURE_FLAG.DEPENDENCY_TYPES.ROLLOUT,
        sharedConstants.FEATURE_FLAG.DEPENDENCY_TYPES.EXPERIMENT,
        sharedConstants.FEATURE_FLAG.DEPENDENCY_TYPES.CANVAS_STEP
      ),
      canvas_id: maybe(string),
      payload: objectOf({
        id: string,
        enabled: boolean,
        fts: maybe(string),
        properties: recordOf({
          key: string,
          value: objectOf({
            type: string,
            value: any,
          }),
        }),
      }),
    })
  ),
  timestamp: number,
});
